import { demoDataUtils } from '@frontend/analytics-shared';
import { SchemaAnalyticsGatewayService, SchemaIO } from '@frontend/schema';

export const trendLineDemoResponse: SchemaIO<(typeof SchemaAnalyticsGatewayService)['GetTrendline']>['output'] = {
  data: demoDataUtils.generateRandomIntArray(10).map((count, index) => ({
    count,
    name: `Demo ${index + 1}`,
  })),
  message: '',
};
